

















import camelCase from 'lodash/camelCase';
import upperFirst from 'lodash/upperFirst';
import {Component, Prop, mixins} from 'nuxt-property-decorator';
import {IPage} from '../node_modules/sitis-nuxt/lib/entities/content-entity';
import {CmsMixin} from '../node_modules/sitis-nuxt/lib/mixins';
import {getOgTitle} from "~/helpers/metaHelper";

interface IPageLayout {
	props: any;
	componentName: string;
	breadcrumbs: any[];
}

interface ICmsPageMeta {
	title: string;
	meta: any[];
	externalData?: any;
}

@Component({
	head (this: CmsPage) {
		if (this.hideHead) {
			return {}
		}
		if (this.contentOnly) {
			return {};
		}

		const head: ICmsPageMeta = {
			title: '',
			meta: [],
		};

		if (this.page) {
			const {page} = this.page;

			if (page) {
				head.title = this.page.page?.titleTag || this.page.page?.title || '';
				head.meta.push({
					name: 'og:title',
					hid: "og:title",
					property: "og:title",
					content: getOgTitle((this.page.page?.titleTag || this.page.page?.title || ''), this.$store.state.appState?.config),
				});

				if (page.description) {
					head.meta.push({
						hid: 'metadescription',
						name: 'description',
						content: page.description,
					});
					head.meta.push({
						name: 'og:description',
						hid: "og:description",
						property: "og:description",
						content: page.description
					});
				}
				if (page.keywords) {
					head.meta.push({
						hid: 'keywords',
						name: 'keywords',
						content: page.keywords,
					});
				}
			}
		}

		return head;
	},
	async fetch(this: CmsPage) {
		const locales = (this.$i18n?.locales || []).map((locale: any) => locale.code);

		/** Выпиливаю locale из пути */
		let witoutLocalePageName = '';
		if (this.pageName) {
			witoutLocalePageName = this.pageName
				.split('/')
				.filter((pathPart) => !locales.includes(pathPart))
				.filter(Boolean)
				.join('/');
			witoutLocalePageName = `/${witoutLocalePageName}`;
		}

		const page = await this.getPage({
			pageIdOrName: this.pageId || witoutLocalePageName,
			contentOnly: this.contentOnly,
		});

		if (page === undefined) {
			this.$nuxt.error({statusCode: 404, message: 'Page not found'});
		}

		if (this.contentOnly) {
			this.contentPage = page!;
		}

		this.setPageLayout();
	},
})
export default class CmsPage extends mixins(CmsMixin) {
	@Prop({type: String}) pageName!: string;
	@Prop({type: Number}) pageId!: number;
	@Prop({type: Number, default: 0}) level!: number;
	@Prop({type: Boolean, default: false}) contentOnly?: boolean;
	@Prop({type: Boolean, default: false}) hideHead?: boolean;
	@Prop({
		type: Object,
		default() {
			return {};
		}
	}) externalData?: any;

	private contentPage: IPage | null = null;
	private pageLayout: IPageLayout | null = null;
  $i18n: any;
  head: any;

	private get currentPage(): IPage {
		return this.contentOnly && this.contentPage ? this.contentPage : this.page;
	}

	private setPageLayout(): void {
		if (this.currentPage) {
			const pageLayout: IPageLayout = {
				componentName: '',
				props: [],
				breadcrumbs: [],
			};

			const layoutName = upperFirst(camelCase(this.currentPage.layout.name.replace(/[\s-_]*/, '')));
			pageLayout.componentName = `${layoutName}Layout`;
			const placeholders = this.currentPage.placeholders as Record<string, unknown>;
			pageLayout.props = {
				...placeholders,
				breadcrumbs: [],
				externalData: this.externalData
			};

			const pathParts = this.$route.path.split('/').filter((p) => !!p);

			if (pathParts.length !== 0) {
				pageLayout.breadcrumbs.push({
					title: 'Главная',
					path: '/',
				});

				pageLayout.props.breadcrumbs.push({
					title: 'Главная',
					path: '/',
				});

				// eslint-disable-next-line no-restricted-syntax
				for (const slug of pathParts) {
					const menu = this.flatMenu.find((m) => m.alias === slug);

					if (!menu) {
						// eslint-disable-next-line no-continue
						continue;
					}

					pageLayout.breadcrumbs.push({
						path: `/${menu.path}`,
						title: menu.title,
					});

					pageLayout.props.breadcrumbs.push({
						path: `/${menu.path}`,
						title: menu.title,
					});
				}
			}

			this.pageLayout = pageLayout;
		}
	}
}
